/**
 * SegmentedControl — compact, hug-width segmented control.
 *
 * A grey track holding a small row of options where the selected one lifts out
 * as a white pill (e.g. Never | Daily | Weekly). Use this for short, inline
 * single-choice pickers. For large, equal-width, full-width tabs use
 * SegmentedTabs instead.
 *
 * @param {Array}  options   - [{ label, value }]
 * @param {string} value     - currently selected value
 * @param {func}   onChange  - called with the selected option's value
 * @param {string} ariaLabel - accessible label for the group
 */
export const SegmentedControl = ({ options = [], value, onChange, ariaLabel }) => {
    return (
        <div className="segmented-control" role="group" aria-label={ariaLabel}>
            {options.map((opt) => {
                const active = value === opt.value;
                return (
                    <button
                        key={opt.value}
                        type="button"
                        aria-pressed={active}
                        className={`segmented-control__option support-m-semibold${active ? " segmented-control__option--active" : ""}`}
                        onClick={() => onChange(opt.value)}
                    >
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
};

export default SegmentedControl;
